import type React from 'react';

import { usePermissionTagFromLocation } from '@vlabs/monokit/shared/lib/use-permission-tag-from-location';
import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';
import { PermissionTagGeneralInfo, PermissionTagStreamGroupListInfo, PermissionTagDepartmentListInfo } from '@vlabs/monokit/widgets';

import { PermissionTagInfo } from './PermissionTagInfo';
import st from './PermissionTagPage.module.sass';
import { PermissionTagPageHeader } from './PermissionTagPageHeader';

function PermissionTagPage(): React.JSX.Element {
  const permissionTag = usePermissionTagFromLocation();

  return (
    <Page>
      <PageContent>
        <PermissionTagPageHeader />
        <div className={st.Root}>
          <div className={st.Content}>
            <div className={st.Panel}>
              <PermissionTagGeneralInfo permissionTag={permissionTag} />
              <PermissionTagStreamGroupListInfo permissionTag={permissionTag} />
            </div>
            <div className={st.Panel}>
              <PermissionTagDepartmentListInfo permissionTag={permissionTag} />
            </div>
          </div>
          <div className={st.Info}>
            <PermissionTagInfo />
          </div>
        </div>
      </PageContent>
    </Page>
  );
}

export { PermissionTagPage };
